export const internalTicketSortFields = {
  code: "id",
  type: "ticketType.name",
  description: "issue",
  createdAt: "createdAt",
  daysOpen: "daysOpen",
  status: "status",
  assignedTo: "assignedEmployee.fullName",
};

export const internalTicketDefaultSort = {
  field: internalTicketSortFields.createdAt,
  direction: "DESC",
};
